import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { DatasetDefinition, DocumentSpecificHiddenFields, HiddenFields } from '../../../datasets/store/types';
import { ClientDatasets } from '../../client-datasets/store/types';
import { MyRiskTolerance, RiskField, RiskTolerance, SelectedRiskField, UpdatedRiskField } from '../../risk-tolerance/store/types';
import { getClientRiskToleranceRoot } from '../../store/selectors';

export const getAllRiskToleranceDatasets = (state: ApplicationState): ClientDatasets[] => getClientRiskToleranceRoot(state).allDatasets;

export const getIsFetchingRiskToleranceDatasets = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).fetchingAllDatasets;

export const getSelectedDatasetId = (state: ApplicationState): number | null => getClientRiskToleranceRoot(state).selectedDataset;

export const getRiskToleranceDatasetDefinitions = (state: ApplicationState): DatasetDefinition[] => getClientRiskToleranceRoot(state).datasetDefinitions;

export const getDocumentSpecificHiddenFields = (state: ApplicationState): DocumentSpecificHiddenFields => getClientRiskToleranceRoot(state).documentHiddenFields;

export const getIsSaving = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).isSaving;

export const getSavedHiddenFields = (state: ApplicationState): HiddenFields => getClientRiskToleranceRoot(state).hiddenFields;

export const getClientRiskToleranceConfig = (state: ApplicationState): (RiskTolerance | MyRiskTolerance)[] | null => getClientRiskToleranceRoot(state).clientRiskToleranceConfig;

export const getCurrentRiskToleranceConfig = (state: ApplicationState): (RiskTolerance | MyRiskTolerance)[] | null => getClientRiskToleranceRoot(state).currentRiskToleranceConfig;

export const getSelectedRiskField = (state: ApplicationState): SelectedRiskField | null => getClientRiskToleranceRoot(state).currentRiskField;

export const getCurrentRiskField = (state: ApplicationState): RiskField | null => {
    const selectedRiskField = getSelectedRiskField(state);
    const currentRiskToleranceConfig = getCurrentRiskToleranceConfig(state);
    if (isNull(selectedRiskField) || isNull(currentRiskToleranceConfig)) {
        return null;
    }
    const { datasetId, fieldId } = selectedRiskField;
    return currentRiskToleranceConfig.find(riskDataset => riskDataset.datasetId === datasetId)?.config.find(riskField => riskField.fieldId === fieldId) || null;
};

export const getRiskToleranceHasUpdated = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).riskToleranceUpdated;

export const getRiskToleranceIncludesOverrides = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).riskToleranceIncludesOverrides;

export const getRiskToleranceRecalculating = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).riskToleranceIsRecalculating;

export const getUnsavedChangesModalOpen = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).unsavedChangesModalOpen;

export const getRiskFieldsUpdatedModal = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).riskFieldsUpdatedModalOpen;

export const getIsFetchingDatasetDefinitions = (state: ApplicationState): boolean => getClientRiskToleranceRoot(state).fetchingDatasetDefinitions;

export const getRiskFieldsUpdated = (state: ApplicationState): UpdatedRiskField[] => getClientRiskToleranceRoot(state).riskFieldsUpdated;

export const getRiskFieldUpdatedModalOpen = (state: ApplicationState): boolean => getRiskFieldsUpdated(state).length > 0 && getRiskFieldsUpdatedModal(state);
